import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from 'react';
import { Outlet, useOutletContext } from 'react-router-dom';
export var ShowSubNavOutlet = function () {
    var setHideSubNav = useOutletContext().setHideSubNav;
    useEffect(function () {
        setHideSubNav(false);
    }, []);
    return _jsx(Outlet, {});
};
